import httpManager from "@/app/shared/utils/httpManager";

export async function markAsReadNotification(notificationId) {
  await httpManager.put(`/notifications/${notificationId}/read/`);
}
